// ORDRE_CARTE (LOT 7c §5) — ordre d'affichage PROVISOIRE = ordre réel du site
// pizznco.fr, relevé le 11/07 01:07 (captures) — JAMAIS l'alphabet. Remplacé par
// l'ordre Coralie dès réception (éditer ces listes uniquement). Positions
// STABLES, aucun tri dynamique. Mapping seed : « Romaine » / « 4 Fromages » =
// suffixes (tomate)/(crème) existants du catalogue. « Douceur Estivale » =
// pizza du mois (rotation mensuelle, position stable en FIN de famille crème).
// « Pizza sur mesure » : section à part, en DERNIER.
//
// FAMILLES visibles (complément 7c) : titres de section STATIQUES verbatim
// TD §5 pour la grille de saisie T1 — ORDRE_CARTE reste la même séquence
// aplatie (dérivée, aucune divergence possible).

export interface FamilleCarte {
  titre: string;
  noms: readonly string[];
}

export const FAMILLES_CARTE: readonly FamilleCarte[] = [
  {
    titre: 'Base tomate',
    noms: [
      'Margarita',
      'Romaine (tomate)',
      'Napolitaine',
      'Chorizo',
      'Cyclope',
      '4 Fromages (tomate)',
      'Chamarelle',
      'Végétarienne',
      'Forestière',
      'Carnivore',
      'Burger',
      'Mexicaine',
      'Orientale',
    ],
  },
  {
    titre: 'Base crème',
    noms: [
      'Romaine (crème)',
      '4 Fromages (crème)',
      'Cendrée',
      'Dulce',
      'Indienne',
      'Ravioles',
      'Savoyarde',
      'Baltique',
      'Paysanne',
      'Normande',
      'Douceur Estivale',
    ],
  },
  { titre: 'Calzones', noms: ['Trady', 'Bleue'] },
  { titre: 'Spéciales', noms: ['Pizza nutella', 'Menu des gones'] },
  // Section à part, en dernier.
  { titre: 'Pizza sur mesure', noms: ['Pizza sur mesure'] },
];

// Nom canonique de la sur mesure (prix seed NON fiable — jamais affiché,
// composition structurée + règle de prix = arbitrage Coralie, voie 2).
export const NOM_SUR_MESURE = 'Pizza sur mesure';

export const ORDRE_CARTE: readonly string[] = FAMILLES_CARTE.flatMap(
  (f) => f.noms,
);
